import PropTypes from "prop-types";

export const brandShape = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    kind: PropTypes.string,
  }),
]);

export const viewShape = PropTypes.shape({
  public_id: PropTypes.string.isRequired,
  view_number: PropTypes.number,
  view_name: PropTypes.string,
  is_active: PropTypes.bool,
});

export const cameraShape = PropTypes.shape({
  public_id: PropTypes.string.isRequired,
  slot_number: PropTypes.number,
  stream_quality: PropTypes.string,
  url_mode: PropTypes.string,
  protocol: PropTypes.string,
  is_active: PropTypes.bool,
  view_count: PropTypes.number,
  views: PropTypes.arrayOf(viewShape),
});

export const deviceShape = PropTypes.shape({
  public_id: PropTypes.string.isRequired,
  name: PropTypes.string,
  host: PropTypes.string,
  rtsp_port: PropTypes.number,
  transport: PropTypes.string,
  brand: brandShape,
  cameras: PropTypes.arrayOf(cameraShape),
});

export const storeShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  local_inference: PropTypes.bool,
});

export const treeNodeShape = PropTypes.shape({
  kind: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string,
  badge: PropTypes.node,
  meta: PropTypes.node,
  rollupCount: PropTypes.number,
  // True when the owning camera is at the view cap (camera and view nodes only).
  viewsFull: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })),
});

export const selectedShape = PropTypes.shape({
  kind: PropTypes.string,
  id: PropTypes.string,
  node: PropTypes.shape({ id: PropTypes.string }),
});
